import React from 'react';

const Baj = () => {
  return (
    <div className="baj-container">
      <form className="baj-form">
        <div className="baj-row">
          <input type="text" placeholder="First Name" className="baj-input" />
          <input type="text" placeholder="Last Name" className="baj-input" />
        </div>

        <div className="baj-row">
          <input type="email" placeholder="Email Address" className="baj-input" />
          <input type="date" placeholder="Date of Birth" className="baj-input" />
        </div>

        <input type="text" placeholder="Nationality" className="baj-input" />

        <div className="baj-row">
          <div className="baj-file-input">
            <label>ID Photo</label>
            <input type="file" accept="image/*" />
          </div>

          <div className="baj-file-input">
            <label>Professional Photo</label>
            <input type="file" accept="image/*" />
          </div>
        </div>

        <div className="baj-file-input">
          <label>Certifications and Degrees</label>
          <input type="file" accept=".pdf,.doc,.docx" multiple />
        </div>

        <button type="submit" className="baj-submit">Submit</button>
      </form>
    </div>
  );
};

export default Baj;